import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { AUTH_ROUTE } from '@constants/routes/route-paths.constant';
import { TranslateService } from '@dv/translate';

export const authRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: AUTH_ROUTE.LOGIN,
  },
  {
    path: AUTH_ROUTE.LOGIN,
    loadComponent: () =>
      import('@auth/login/login.component').then((m) => m.LoginComponent),
    title: () => inject(TranslateService).t('Login'),
  },
];
